module.exports = __webpack_public_path__ + "static/img/field_health.8a529d9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/field_health.png
// module id = Yawj
// module chunks = 1